type Prop = {
  show: boolean
}

const LoadingPanel: React.FC<Prop> = ({ show }) => {

  if (!show) return null;

  return (
    <div className='k-loading-mask'>
      <span className='k-loading-text'>Loading</span>
      <div className='k-loading-image'></div>
      <div className='k-loading-color'></div>
    </div>
  )
}

export default LoadingPanel;
